import React from "react";
import ArrowIcon from "@ecologi/assets/icons/Carousel/carousel_navigation_arrow.svg";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

type CarouselButtonProps = {
  enabled: boolean;
  onClick: () => void;
  bgColor?: string;
};

const CarouselButton = styled.button<{ bgColor?: string }>`
  background-color: ${(props) => props.bgColor || props.theme.colors.mist};
  padding: 12px 15px 8px 15px;
  border: none;
  cursor: pointer;
`;

const DisabledCSS = css`
  stroke: #d9eaf3;
  path {
    fill: #cdd7dc;
  }
`;

const NextButtonIcon = styled(ArrowIcon)<{
  disabled?: boolean;
}>`
  ${(props) => props.disabled && DisabledCSS};
`;

const PrevButtonIcon = styled(NextButtonIcon)<{
  disabled?: boolean;
}>`
  transform: rotate(182deg);
  ${(props) => {
    return props.disabled && DisabledCSS;
  }};
`;

export const PrevButton = ({
  enabled,
  onClick,
  bgColor,
}: CarouselButtonProps) => {
  return (
    <CarouselButton
      onClick={onClick}
      disabled={!enabled}
      aria-label="Previous slide"
      data-testid="arrow-navigation"
      bgColor={bgColor}
    >
      <PrevButtonIcon disabled={!enabled} />
    </CarouselButton>
  );
};

export const NextButton = ({
  enabled,
  onClick,
  bgColor,
}: CarouselButtonProps) => {
  return (
    <CarouselButton
      onClick={onClick}
      disabled={!enabled}
      aria-label="Next slide"
      data-testid="arrow-navigation"
      bgColor={bgColor}
    >
      <NextButtonIcon disabled={!enabled} />
    </CarouselButton>
  );
};
